import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCardHeader from 'components/common/FalconCardHeader';
import React, { useState, useEffect } from 'react';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import CustomerSatisfactionChart from './CustomerSatisfactionChart';
import useToken from 'hooks/useToken';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useToast } from 'context/providers/ToastProvider';

const CustomerSatisfaction = () => {
    const [cargando, setCargando] = useState(false);
    const { setToken, token } = useToken();
    const { showErrorToast } = useToast();
    const [satisfaction, setSatisfaction] = useState({
        total: 0,
        positive: 0,
        negative: 0,
        positivePct: 0,
        negativePct: 0
    });

    const ObtenerCustomerSatisfaction = async () => {
        setCargando(true);
        const response = await fetch("/api/soportetecnico/ObtenerCustomerSatisfaction/",
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

        if (response.ok) {
            const data = await response.json();
            if (data && data.satisfaction) {
                setSatisfaction({
                    total: data.satisfaction.total || 0,
                    positive: data.satisfaction.positive || 0,
                    negative: data.satisfaction.negative || 0,
                    positivePct: data.satisfaction.positivePct || 0,
                    negativePct: data.satisfaction.negativePct || 0
                });
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
        setCargando(false);
    };

    useEffect(() => {
        ObtenerCustomerSatisfaction();
    }, []);

    return (
        <Card className="card h-100">
            <FalconCardHeader
                title="Total Customer Satisfaction 12 M"
                titleTag="h6"
                className="border-200 border-bottom py-2"
            />
            <Card.Body className="p-3 d-flex aligm-items-center">
                {cargando ? (
                    <div className="w-100">
                        <Skeleton height={200} />
                    </div>
                ) : (
                    <CustomerSatisfactionChart satisfaction={satisfaction} />
                )}
            </Card.Body>
            <Card.Footer className="border-top border-200 py-0">
                <Row>
                    <Col className="border-end border-200 py-3 d-flex justify-content-center">
                        <div>
                            <h6 className="text-600 mb-1 fs--2">Positive</h6>
                            <h6 className="fs-0 mb-0 d-flex align-items-center">
                                {cargando ? (
                                    <Skeleton width={60} />
                                ) : (
                                    <>
                                        {satisfaction.positive}
                                        <Badge
                                            pill
                                            bg="transparent"
                                            className="px-0 text-success d-flex align-items-start"
                                        >
                                            <FontAwesomeIcon
                                                icon="caret-up"
                                                className="fs--2 ms-2 me-1"
                                            />
                                            {satisfaction.positivePct}%
                                        </Badge>
                                    </>
                                )}
                            </h6>
                        </div>
                    </Col>
                    <Col className="py-3 d-flex justify-content-center">
                        <div>
                            <h6 className="text-600 mb-1 fs--2">Negative</h6>
                            <h6 className="fs-0 mb-0 d-flex align-items-center">
                                {cargando ? (
                                    <Skeleton width={60} />
                                ) : (
                                    <>
                                        {satisfaction.negative}
                                        <Badge
                                            pill
                                            bg="transparent"
                                            className="px-0 text-danger d-flex align-items-start"
                                        >
                                            <FontAwesomeIcon
                                                icon="caret-down"
                                                className="fs--2 ms-2 me-1"
                                            />
                                            {satisfaction.negativePct}%
                                        </Badge>
                                    </>
                                )}
                            </h6>
                        </div>
                    </Col>
                </Row>
            </Card.Footer>
        </Card>
    );
};

CustomerSatisfaction.propTypes = {
};

export default CustomerSatisfaction;
